export const GET_LIST = '/building_owner/get_list';
export const SHOW_DATA = '/building_owner/show_data';
export const CREATE_DATA = '/building_owner/create_data';
export const UPDATE_DATA = '/building_owner/update_data';
export const REMOVE_DATA = '/building_owner/remove_data';


export const FORM_DATA = {
  name: '',
  description: '',
  is_active: false,
};